module.exports = __webpack_public_path__ + "static/media/sample_cha_exports_container_updates.5a4ca2df.csv";